"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateMean = exports.aggregateSum = void 0;
const aggregateSum = (items, k) => items.reduce((acc, curr, i) => (typeof curr[k] === 'number' ? acc + curr[k] : acc), 0);
exports.aggregateSum = aggregateSum;
const aggregateMean = (items, k) => (0, exports.aggregateSum)(items, k) / (items.length > 0 ? items.length : 1);
exports.aggregateMean = aggregateMean;
